<template>
  <v-container class="max-width-1200">

    <!-- partners -->
    <v-row class="py-8 text-left justify-center">
      <v-col style="display:contents;">
        <div
          v-for="(item,index) in partners"
          :key="index"
          class="ma-4">
            <img
              :src="item.img"
              loading="lazy"
              :alt="item.name + ' logó'"
              height="30" :width="item.width"
              style="object-fit:contain;">
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Studies',
    extends: DataComponentBase,

    data: () => ({
      partners: [
        { img: require("@/assets/partners/partner_00_abroncs.png"),                              name: "Abroncs ház",                     width: '45'  },
        { img: require("@/assets/partners/partner_00_flextronics.png"),                          name: "Flextronics International Kft.",  width: '60'  },
        { img: require("@/assets/partners/partner_00_goodmills.png"),                            name: "Goodmils Magyarszág",             width: '90'  },
      ],
    }),

    computed: {
    },

    methods: {
    },
  }
</script>
